export default defineAppConfig({
	ui: {
		notifications: {
			// Show toasts at the top right of the screen
			position: 'top-0 right-0'
		}
	}
})
